import produce from 'immer'
import { Redux } from 'types/local'
import { chatActions } from './chat.actions'

export type State = Redux.UserState['chatFeature']

const { types } = chatActions

export const initialState: State = {
  data: [],
  pegeSize: 50,
  total: 0,
}

export const chatFeatureReducer = produce((state: State, action: Redux.Action) => {
  switch (action.type) {
    case types.GET_CHAT_MESSAGE.REQUEST:
      break
    case types.GET_CHAT_MESSAGE.SUCCESS:
      state.data = action.payload.data
      state.pegeSize = action.payload.per_page
      state.total = action.payload.total
      break
    case types.GET_CHAT_MESSAGE.FAILED:
      break
    case types.RECEIVED_MESSSAGE:
      state.data = [...[action.payload], ...state.data]
    // no default
  }
}, initialState)
